import { dateFormat } from '../helpers';
import Page from '../layout/components/Page';
import Modal from '../components/Common/Modal';
import Paginate from '../components/Common/Paginate';
import { TransactionType } from '../helpers/constants';
import { DateFilter } from '../components/Common/DateFilter';
import LoadingIndicator from '../components/Common/LoadingIndicator';
import TransactionSizeFilter from '../components/Common/TransactionSizeFilter';
import { useFetchTransactionHistory } from '../hooks/transactions/useFetchTransactions';
import { NoContent } from '../components/Common/NoContent';
import { useErrorHandler } from 'react-error-boundary';

const TransactionsPage = () => {
  const {
    error, toggleForm, showForm, transactionHistory, fetching, paginatedTransactionHistory, pageQuery, dateFromSelection, dateToSelection, setSizeSelection, setDateToSelection, setDateFromSelection, handleFilterTransactions
  } = useFetchTransactionHistory()
  useErrorHandler(error)

  const renderChildren = (
    <>
      <button className='btn btn-sm btn-flex btn-light-primary btn-active-primary fw-bolder me-2' onClick={toggleForm}>
        <i className='bi bi-filter'></i>
        Filter Transactions
      </button>
    </>
  );

  return (
    <Page
      title="Transactions"
      icon="bi-credit-card-2-front"
      toolbarChildren={renderChildren}
    >
      <div className="card">
        <div className="card-body">
          {fetching ? (
            <LoadingIndicator message="" />
          ) : transactionHistory.length < 1 ? <NoContent message='No transaction history found' /> : (
            <div className="table-responsive">
              <table className="table table-bordered table-hover align-middle gs-0 gy-4">
                <thead>
                  <tr className="fw-bolder text-muted bg-light">
                    <th className="min-w-100px">Amount</th>
                    <th className="min-w-100px">Type</th>
                    <th className="min-w-70px">Date Created</th>
                    <th className="min-w-70px">Description</th>
                    <th className="min-w-70px">Balance</th>
                  </tr>
                </thead>
                <tbody>
                  {transactionHistory &&
                    transactionHistory.length >= 1 &&
                    transactionHistory.map((transaction) => (
                      <tr key={transaction.id}>
                        <td>
                          <span className="text-muted fw-bold text-muted d-block fs-7">
                            {parseFloat(transaction.amount).toLocaleString()}
                          </span>
                        </td>
                        <td className="align-top">
                          <span
                            className={`badge badge-sm ${
                              transaction.type === TransactionType.CREDIT
                                ? "badge-light-accepted"
                                : "badge-light-cancelled"
                            }`}
                          >
                            {transaction.type}
                          </span>
                        </td>
                        <td className="align-top">
                          <span className="text-muted fw-bold text-muted d-block fs-7">
                            {dateFormat(transaction.created_at)}
                          </span>
                        </td>
                        <td className="align-top">
                          <span className="text-muted fw-bold text-muted d-block fs-7">
                            {transaction.description}
                          </span>
                        </td>
                        <td className="align-top">{transaction.balance}</td>
                      </tr>
                    ))}
                </tbody>
              </table>

              {paginatedTransactionHistory && (
                <Paginate
                  pagination={paginatedTransactionHistory}
                  pageLink="/transactions"
                  pageQuery={pageQuery}
                />
              )}
            </div>
          )}
        </div>
      </div>

      <Modal show={showForm} toggle={toggleForm} title="Filter Transactions">
        <label className="fs-8 text-muted">Transactions per page</label>
        <TransactionSizeFilter onSelect={setSizeSelection} />
        <div style={{ display: "inline-block" }}>
          <label className="fs-8 text-muted mt-3">Date From</label>
          <DateFilter onSelect={setDateFromSelection} dateSelection={dateFromSelection} />
        </div>
        <div style={{ display: "inline-block" }}>
          <label className="fs-8 text-muted mt-3">Date To</label>
          <DateFilter onSelect={setDateToSelection} dateSelection={dateToSelection} />
        </div>
        <button
          className="btn btn-sm btn-light-primary fw-bolder text-center mt-10 align-center"
          data-kt-menu-dismiss="true"
          onClick={() => handleFilterTransactions()}
        >
          Apply
        </button>
      </Modal>
    </Page>
  );
};

export default TransactionsPage;
